import React, { useContext } from "react";
import styles from "./index.module.scss";

import img1 from "../../../../assets/images/landingPage/comingsoon/1.jpg";
import img2 from "../../../../assets/images/landingPage/comingsoon/2.jpg";
import img3 from "../../../../assets/images/landingPage/comingsoon/3.jpg";
import img4 from "../../../../assets/images/landingPage/comingsoon/4.jpg";
import img5 from "../../../../assets/images/landingPage/comingsoon/5.jpg";
import img6 from "../../../../assets/images/landingPage/comingsoon/6.jpg";
import img7 from "../../../../assets/images/landingPage/comingsoon/7.jpg";
import img8 from "../../../../assets/images/landingPage/comingsoon/8.jpg";
import img9 from "../../../../assets/images/landingPage/comingsoon/9.jpg";
import img10 from "../../../../assets/images/landingPage/comingsoon/10.jpg";

import { authContext } from "../../../../contexts/AuthContext/AuthContextProvider";

const cardData = [
  {
    enable: true,
    img: "https://firebasestorage.googleapis.com/v0/b/docflix-d8cab.appspot.com/o/video%2Fvideo-lpo5a2ud%2FthumbnailUrl.jpg%3Fx%3D0.47439989063799537?alt=media&token=05a811e4-7266-455b-91e3-f375b025453a",
    title: "5W1H",
    type: "series",
    id: "series-lpo3yxfy",
  },
  {
    enable: true,
    img: "https://firebasestorage.googleapis.com/v0/b/docflix-d8cab.appspot.com/o/video%2Fvideo-lphvcoc7%2FthumbnailUrl.jpg%3Fx%3D0.40438734366895823?alt=media&token=03849edd-96d0-4510-b273-8986112a07b4",
    title: "Non Glucocentric Diabetes Management",
    type: "series",
    id: "series-lphv7on3",
  },
  {
    enable: true,
    img: "https://firebasestorage.googleapis.com/v0/b/docflix-d8cab.appspot.com/o/video%2Fvideo-llurnldl%2FthumbnailUrl.jpg%3Fx%3D0.9978595578166767?alt=media&token=bee0b43c-1d06-4c6b-b01f-1677454ff121",
    title: "Optimising Oocyte Pick-Up",
    type: "series",
    id: "series-lkv68jru",
  },
  {
    enable: true,
    img: "https://firebasestorage.googleapis.com/v0/b/docflix-d8cab.appspot.com/o/video%2Fvideo-lpnrvk8c%2FthumbnailUrl.jpg%3Fx%3D0.08742402063034294?alt=media&token=e61e6729-2e44-4779-b82c-5a09d879a1fd",
    title: "Early Combination VS. Step-up Approach in Diabetes",
    type: "series",
    id: "series-lpnpt6kf",
  },
  {
    enable: true,
    img: "https://firebasestorage.googleapis.com/v0/b/docflix-d8cab.appspot.com/o/video%2Fvideo-lojp2g9b%2FthumbnailUrl.jpg%3Fx%3D0.7161894810441052?alt=media&token=7f926c8f-236b-4864-95df-cf7a29ddc106",
    title: "Dr. Rajesh Swarnakar - The Midas",
    type: "series",
    id: "series-lilw6p0q",
  },
  {
    enable: false,
    img: img1,
    title: "Good Morning - News",
  },
  {
    enable: true,
    img: img2,
    title: "Hypertension Treatment Algorithm",
    type: "video",
    id: "video-l52ff15p",
  },
  { enable: false, img: img3, title: "Year in Review" },
  {
    enable: false,
    img: img4,
    title: "The Great Indian Medicine Show",
  },
  { enable: false, img: img5, title: "Acute Coronary Syndrome" },
  { enable: false, img: img6, title: "Stitch in Time" },
  {
    enable: true,
    img: img7,
    title: "Cardio - Unflip",
    type: "series",
    id: "series-l67t1f0r",
  },
  {
    enable: true,
    img: img8,
    title: "Medico - Legal Series",
    type: "series",
    id: "series-l67tf9cs",
  },
  {
    enable: true,
    img: img9,
    title: "Out Of Office",
    type: "series",
    id: "series-l67q6uvo",
  },
  // { enable: true, img: img10, title: "The Guideline Zodiac" },
];

const VideoCard = ({ video, toggleSignInbtn }) => {
  return (
    <a href={`./${video.type}/${video.id}`} className={styles.card}>
      <div className={styles.videoCard}>
        <div>
          <img
            src={video.img}
            alt={video.title}
            className={styles.videoThumb}
          />
        </div>
        <div className={styles.title}>{video.title}</div>
      </div>
    </a>
  );
};

const ComingSoonSection = () => {
  const { toggleSignInbtn } = useContext(authContext);

  return (
    <div className={styles.videosSection}>
      <div className={styles.videosWrapper}>
        {cardData.map(
          (video, index) =>
            video.enable && (
              <VideoCard
                key={index}
                video={video}
                toggleSignInbtn={toggleSignInbtn}
              />
            )
        )}
      </div>
    </div>
  );
};

export default ComingSoonSection;
